import React from 'react';

import _ from 'lodash';

import { Text } from 'common-components/typography';
import { rosterConfig } from '../../roster-config';
import { Box, Avatar } from '@good/ui/core';

const { TIMELINE_ROW_HEIGHT } = rosterConfig;

// Change this to show empty rows whenever there's no data. A bit buggy, so setting it to 0 for now.
const EMPTY_ROW_COUNT = 1;

export const EmptySideColumn = ({ numberOfRows = EMPTY_ROW_COUNT, type = 'customer' }) => {
  return (
    <>
      {_.times(numberOfRows, (idx) => (
        <Box
          className='roster-gray flex-row bordered-right bordered-bottom'
          style={{ height: TIMELINE_ROW_HEIGHT }}
          key={idx}
          px='lg'
        >
          <div className='flex-row align-center'>
            <div className='mr-4'>
              <Avatar size='md' radius={type === 'customer' ? undefined : 'md'} />
            </div>
            <div className='flex-column'>
              <Text color='tertiary' size='regular'>
                No {type === 'customer' ? 'customers' : 'team members'}
              </Text>
            </div>
          </div>
        </Box>
      ))}
    </>
  );
};
